import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from '../../assets/Finance Logo.png'

function Footer() {
  const year = 2026;
  return (
    <footer className="fi-footer mt-5">
      <Container>
        <Row className="gy-4">
          <Col lg={3} md={6}>
            <h5 className="fi-brand" style={{ color: "#fff" }}>
              <img src={logo} alt="Finance Info"  style={{ height: "50px" }}/>
            </h5>
            <p className="mt-2" style={{ maxWidth: 320 }}>
              Smart, simple and trustworthy personal finance content for India
              budgeting, investing, tax and free calculators in one place.
            </p>
          </Col>

          <Col lg={3} md={4} xs={6} className="text-center">
            <h6>Finance</h6>
            <Link to="/category/personal-finance">Personal Finance</Link>
            <Link to="/category/education">Finance Education</Link>
            <Link to="/category/tax">Tax (India)</Link>
            <Link to="/category/banking">Banking</Link>
          </Col>

          <Col lg={3} md={4} xs={6} className="text-center">
            <h6>Markets &amp; Insights</h6>
            <Link to="/category/investment">Investment</Link>
            <Link to="/category/trending">Trending</Link>
            <Link to="/calculators">All Calculators</Link>
          </Col>

          <Col lg={3} md={4} xs={6} className="text-center">
            <h6>Pages</h6>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/category/blog">Blog</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </Col>
        </Row>

        <hr style={{ borderColor: "rgba(255,255,255,0.12)", margin: "2rem 0 1rem" }} />
        <div className="d-flex flex-wrap justify-content-center align-items-center small">
          <span>© {year}. For educational purposes only not financial advice.</span>
          {/* <span>Made with ❤️ for smarter money decisions.</span> */}
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
